function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon/navigation/ic-close-small");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "icon/navigation/ic-close-small",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M14.885,7.705 L12,10.59 L9.115,7.705 C8.72563925,7.31563925 8.09436075,7.31563925 7.705,7.705 L7.705,7.705 C7.31563925,8.09436075 7.31563925,8.72563925 7.705,9.115 L10.59,12 L7.705,14.885 C7.31563925,15.2743607 7.31563925,15.9056393 7.705,16.295 L7.705,16.295 C8.09436075,16.6843607 8.72563925,16.6843607 9.115,16.295 L12,13.41 L14.885,16.295 C15.2743607,16.6843607 15.9056393,16.6843607 16.295,16.295 L16.295,16.295 C16.6843607,15.9056393 16.6843607,15.2743607 16.295,14.885 L13.41,12 L16.295,9.115 C16.6843607,8.72563925 16.6843607,8.09436075 16.295,7.705 L16.295,7.705 C15.9056393,7.31563925 15.2743607,7.31563925 14.885,7.705 Z",
  id: "Path",
  fill: "#bebebe"
}));

var SvgIcCloseSmallfaded = function SvgIcCloseSmallfaded(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcCloseSmallfaded, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-close-small.faded.0f3c899a.svg";
export { ForwardRef as ReactComponent };